import { mapKeys } from 'lodash/fp'

// Remaps keys within an object to string specified in keyMap
// ex: renameKeys({ first: 'one' })({first: 1}) // { one: 1 }
const renameKeys = keyMap => mapKeys(key => (keyMap[key] ? keyMap[key] : key))
export default renameKeys
